import "./index.scss";
import PropTypes from "prop-types";
// import {Icon} from "semantic-ui-react";

/**
 * Loading screen component that displays while the application or data is loading.
 * Shows loading text and instructions for users experiencing slow connections.
 * Provides guidance on what to do if loading takes too long.
 *
 * With `failed`, it says the games couldn't be loaded instead (the data came
 * back empty from both NACA-Core and Firebase) and offers a Try again button,
 * rather than opening an app with no games in it.
 *
 * @param {Object} props - Component props
 * @param {boolean} [props.failed] - Show the "couldn't load" version
 * @returns {JSX.Element} Loading screen with spinner placeholder and user instructions
 */
const LoadingScreen = ({ failed = false }) => {
  if (failed) {
    return (
      <div className="loadingscreen_container" role="alert">
        <div className="loadingscreen_contentContainer">
          <p className="loadingscreen_content">Oh no!</p>
          <p className="loadingscreen_contentSmall">
            We couldn&apos;t load the games.
          </p>
          <p className="loadingscreen_contentSmall">
            Please check your internet connection.
          </p>
          <button
            type="button"
            className="loadingscreen_button hovercursor"
            onClick={() => window.location.reload()}
          >
            Try again
          </button>
        </div>
      </div>
    );
  }
  return (
    <div className="loadingscreen_container" role="status" aria-live="polite" aria-label="Loading application">
      <div className="loadingscreen_contentContainer">
        <div className="loadingscreen_content">
          {/* <Icon fitted loading size="huge" name="spinner" /> */}
        </div>
        <p className="loadingscreen_content">Loading...</p>
        <p className="loadingscreen_contentSmall">
          Please make sure you have a strong internet connection.
        </p>
        <p className="loadingscreen_contentSmall">
          If this screen lasts longer than 10 seconds, reload your browser.
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;

LoadingScreen.propTypes = {
  failed: PropTypes.bool,
};
